export default {
    ONTOLOGICAL_MODEL_WAS_CHANGED: "Онтологическая модель обновлена другим пользователем.\nПожалуйста, обновите страницу"
};
